<template>
  <v-navigation-drawer
    :value="isAmazonSESConfigOpen"
    :permanent="isAmazonSESConfigOpen"
    width="600px"
    max-width="100vw"
    right
    fixed
    temporary
    style="z-index: 11; transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        :button-save="!!payload.id"
        @close="close"
        @save="submitData"
        :title="$t('organization.details.tabs.integrations.amazon_ses.title')"
        type-title="icon"
        icon="edit"
      />
      <v-progress-linear v-if="loading" indeterminate height="5" class="my-0" />
      <v-card-text v-else style="overflow-y: auto; height: calc(100vh - 64px)">
        <v-container v-if="!payload.id" class="pa-5">
          <v-row dense justify="center">
            <v-col cols="12" sm="10">
              <v-select
                :value="type"
                :items="accountTypes"
                @change="setType"
                label="Cuenta"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="10">
              <div class="subtitle-2 mb-5">
                {{
                  $t(
                    'organization.details.tabs.integrations.amazon_ses.preinfo'
                  )
                }}
              </div>
            </v-col>
            <v-col cols="6" sm="5">
              <v-btn @click="submitData" color="primary" block>
                {{ $t('general.activate') }} 
              </v-btn>
              <v-btn @click="() => submitData({temporal: true})" color="primary" block class="mt-4">
                {{ $t('general.activate') }} (temporal)
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-else class="pa-5">
          <v-row dense justify="center">
            <v-col cols="12" sm="10">
              <v-select
                :value="type"
                :items="accountTypes"
                @change="setType"
                label="Cuenta"
              ></v-select>
            </v-col>
            <v-col v-if="payload.config.invalidKeys" cols="12" sm="10">
              <v-alert type="error" elevation="5" border="right" colored-border>
                {{
                  $t(
                    'organization.details.tabs.integrations.amazon_ses.invalid_keys'
                  )
                }}
              </v-alert>
            </v-col>
            <v-col cols="12" sm="10">
              <v-alert
                :type="payload.config.subscriptionSNS ? 'success' : 'error'"
                elevation="5"
                border="right"
                colored-border
              >
                {{
                  payload.config.subscriptionSNS
                    ? $t(
                        'organization.details.tabs.integrations.amazon_ses.sns_configured'
                      )
                    : $t(
                        'organization.details.tabs.integrations.amazon_ses.sns_not_configured'
                      )
                }}
              </v-alert>
            </v-col>
            <v-col cols="12" sm="10">
              <div class="subtitle-2">
                {{
                  $t('organization.details.tabs.integrations.amazon_ses.info')
                }}
              </div>
            </v-col>
            <v-col cols="12" sm="10">
              <v-text-field
                v-model="payload.config.accessKeyId"
                v-validate="'required'"
                :error-messages="errors.collect('Access key')"
                label="Access key"
                data-vv-name="Access key"
                required
              />
            </v-col>
            <v-col cols="12" sm="10">
              <v-text-field
                v-model="payload.config.secretAccessKey"
                v-validate="'required'"
                :error-messages="errors.collect('Secret key')"
                label="Secret key"
                data-vv-name="Secret key"
                required
              />
            </v-col>
            <v-col cols="12" sm="10">
              <v-select
                v-model="payload.config.region"
                :items="regions"
                v-validate="'required'"
                :error-messages="errors.collect('Region')"
                label="Region"
                data-vv-name="Region"
                required
              />
            </v-col>
            <v-col cols="12" sm="10">
              <v-text-field
                v-model="payload.config.from"
                v-validate="'required'"
                :error-messages="errors.collect('Email')"
                type="email"
                label="Email"
                data-vv-name="Email"
                required
              />
            </v-col>
            <v-col cols="12" sm="10">
              <v-text-field
                v-model="payload.config.configurationSet"
                v-validate="'required'"
                :error-messages="errors.collect('Configuration Set')"
                label="Configuration Set"
                data-vv-name="Configuration Set"
                required
              />
            </v-col>
            <v-col cols="12" sm="10">
              <v-alert type="info" elevation="5" border="right" colored-border>
                <div class="px-2">
                  <div class="mb-2">
                    {{
                      $t(
                        'organization.details.tabs.integrations.amazon_ses.sns_info'
                      )
                    }}
                  </div>
                  <div class="caption">Endpoint Amazon SNS</div>
                  <v-text-field
                    :value="urlWebhook"
                    @click:append-outer="copyText(urlWebhook)"
                    append-outer-icon="file_copy"
                    label="Endpoint Amazon SNS"
                    hide-details
                    readonly
                    dense
                    solo
                    flat
                    background-color="rgba(125,125,125,.2)"
                  />
                </div>
              </v-alert>
            </v-col>
            <v-col v-if="payload.id" cols="6" sm="5">
              <v-btn
                v-if="showCreateAWS"
                @click="createAWS = true"
                color="primary"
                block
                depressed
                class="my-2"
              >
                Crear cuenta de AWS
              </v-btn>
              <v-btn
                @click="removeDialog = true"
                color="primary"
                block
                depressed
                class="my-2"
              >
                {{ $t('general.delete') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <input id="copy-text" v-model="copyTextField" type="hidden" />
      <BaseConfirmDialog
        v-if="createAWS && accountType.id"
        :cancel-text="$t('general.cancel')"
        :accept-text="$t('general.confirm')"
        @close="createAWS = false"
        @proceed="confirmCreateAWS()"
        :title="
          $t(
            'organization.details.tabs.integrations.amazon_ses.createAWS.title'
          )
        "
        :description="
          $t(
            'organization.details.tabs.integrations.amazon_ses.createAWS.description'
          )
        "
      />
      <BaseConfirmDialog
        v-if="removeDialog && accountType.id"
        :cancel-text="$t('general.cancel')"
        :accept-text="$t('general.delete')"
        @close="removeDialog = false"
        @proceed="confirmRemove()"
        :title="
          $t('organization.details.tabs.integrations.amazon_ses.remove.title')
        "
        :description="
          $t('organization.details.tabs.integrations.amazon_ses.remove.text')
        "
      />
    </v-card>
    <v-progress-linear
      v-if="submitLoading"
      indeterminate
      color="primary"
      absolute
      style="top: 64px;"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import config from '@/config'
import BaseToolbar from '@/components/BaseToolbar.vue'
import BaseConfirmDialog from '@/components/BaseConfirmDialog.vue'

export default {
  name: 'AmazonSES',
  components: {
    BaseToolbar,
    BaseConfirmDialog
  },
  data() {
    return {
      loading: false,
      submitLoading: false,
      removeDialog: false,
      createAWS: false,
      url: config.b_path,
      copyTextField: '',
      accountTypes: [
        { text: 'Autoresponder', value: 'autoresponder' },
        { text: 'Petition notification', value: 'petition_notification' },
        { text: 'Petition target', value: 'petition_target' },
        { text: 'Certificados', value: 'certificate' },
        { text: 'Automation', value: 'automation' }
      ],
      payload: {
        name: 'amazon_ses',
        config: {
          accessKeyId: null,
          secretAccessKey: null,
          region: null,
          from: null,
          invalidKeys: false,
          subscriptionSNS: false,
          configurationSet: null
        }
      },
      regions: [
        { text: 'US East (N. Virginia)', value: 'us-east-1' },
        { text: 'EE.UU. Oeste (Oregón)', value: 'us-west-2' },
        { text: 'Asia Pacífico (Mumbai)', value: 'ap-south-1' },
        { text: 'Asia Pacífico (Sídney)', value: 'ap-southeast-2' },
        { text: 'Canadá (Central)', value: 'ca-central-1' },
        { text: 'Europa (Fráncfort)', value: 'eu-central-1' },
        { text: 'Europa (Irlanda)', value: 'eu-west-1' },
        { text: 'Europa (Londres)', value: 'eu-west-2' },
        { text: 'América del Sur (São Paulo)', value: 'sa-east-1' }
      ]
    }
  },
  watch: {
    async isAmazonSESConfigOpen(newVal) {
      if (newVal) {
        this.loading = true
        await this.setLocalData()
        this.loading = false
      }
    },
    accountType() {
      this.setEditData()
    }
  },
  computed: {
    ...mapState({
      orgId: ({ organization: { orgId } }) => orgId,
      integrations: ({ organization: { integrations } }) => integrations,
      organization: ({ organization: { organization } }) => organization
    }),
    ...mapGetters({
      isAmazonSESConfigOpen: 'accounts/isAmazonSESConfigOpen',
      type: 'accounts/type',
      accounts: 'accounts/accounts',
      account: 'accounts/account'
    }),
    integrationAmazonSES() {
      return this.integrations.find(({ name }) => name === 'AmazonSES')
    },
    accountType() {
      return this.accounts.find(({ type }) => type === this.type)
    },
    urlWebhook() {
      const { url, type, orgId } = this
      const codeWebhook = Buffer.from(
        `webhook-for-companyid-${orgId}`
      ).toString('base64')
      const accountTypeBase64 = Buffer.from(type).toString('base64')
      return `${url}webhook/emails?orgId=${codeWebhook}&accountType=${accountTypeBase64}`
    },
    showCreateAWS() {
      let show = true
      if (
        this.payload.config.accessKeyId &&
        this.payload.config.secretAccessKey
      ) {
        show = false
      }
      return show
    }
  },
  async created() {
    await this.getOrganizationData()
  },
  methods: {
    ...mapActions({
      setUser: 'localStorage/setUser',
      getAccounts: 'accounts/getAccounts',
      getAccount: 'accounts/getAccount',
      saveAccount: 'accounts/saveAccount',
      updateAccount: 'accounts/updateAccount',
      removeAccount: 'accounts/removeAccount',
      getOrganizationData: 'organization/getOrganizationData',
      createAWSAccount: 'accounts/createAWSAccount'
    }),
    ...mapMutations({
      setType: 'accounts/setType',
      toggleAmazonSESConfig: 'accounts/toggleAmazonSESConfig'
    }),
    close() {
      this.toggleAmazonSESConfig(false)
      this.cleanData()
    },
    async setLocalData() {
      try {
        await this.getAccounts({ organizationId: this.orgId })
      } catch (error) {
        this.$noty.error(
          this.$t(
            'organization.details.tabs.integrations.amazon_ses.messages.error.get_all'
          )
        )
      }
      this.setEditData()
    },
    setEditData() {
      const { accountType } = this

      if (accountType && accountType.id) {
        const { config } = accountType
        this.payload = {
          ...accountType,
          config: { ...config }
        }
      } else {
        this.cleanData()
      }
    },
    async submitData(p) {
      let temporal = null
      if(!!p) {
        temporal = !!p.temporal
      }
      this.submitLoading = true
      const {
        orgId,
        type,
        payload,
        accountType,
        integrationAmazonSES,
        saveAccount,
        updateAccount,
        setLocalData,
        organizationId,
        setUser,
        close
      } = this
      if (accountType && accountType.id) {
        try {
          const isValid = await this.$validator.validateAll()
          if (!isValid) {
            return
          }
          await updateAccount({
            organizationId: orgId,
            id: payload.id,
            body: {
              ...payload,
              type
            }
          })
          await setLocalData()
          if (!this.payload.config.invalidKeys) {
            close()
          }
          this.$noty.success(
            this.$t(
              'organization.details.tabs.integrations.amazon_ses.messages.success.update'
            )
          )
        } catch (error) {
          this.$noty.error(
            this.$t(
              'organization.details.tabs.integrations.amazon_ses.messages.error.update'
            )
          )
        }
      } else {
        try {
          await saveAccount({
            organizationId: orgId,
            body: {
              ...payload,
              type,
              temporal: !!temporal,
              integration_id: integrationAmazonSES
                ? integrationAmazonSES.id
                : null
            }
          })
          await setLocalData()
          this.$noty.success(
            this.$t(
              'organization.details.tabs.integrations.amazon_ses.messages.success.save'
            )
          )
        } catch (error) {
          this.$noty.error(
            this.$t(
              'organization.details.tabs.integrations.amazon_ses.messages.error.save'
            )
          )
        }
      }
      await setUser({ organizationId })
      this.submitLoading = false
    },
    async confirmRemove() {
      const { orgId, payload } = this
      try {
        await this.removeAccount({
          organizationId: orgId,
          id: payload.id
        })
        this.cleanData()
        this.$noty.success(
          this.$t(
            'organization.details.tabs.integrations.amazon_ses.messages.success.remove'
          )
        )
      } catch (err) {
        this.$noty.error(
          this.$t(
            'organization.details.tabs.integrations.amazon_ses.messages.error.remove'
          )
        )
      }
    },
    cleanData() {
      this.loading = false
      this.submitLoading = false
      this.removeDialog = false
      this.copyTextField = ''
      this.payload = {
        name: 'amazon_ses',
        config: {
          accessKeyId: null,
          secretAccessKey: null,
          region: null,
          from: null,
          invalidKeys: false,
          subscriptionSNS: false,
          configurationSet: null
        }
      }
      this.$validator.reset()
    },
    async copyText(text) {
      this.copyTextField = text
      const textToCopy = document.querySelector('#copy-text')
      await textToCopy.setAttribute('type', 'text')
      textToCopy.select()
      try {
        const successful = document.execCommand('copy')
        if (successful) {
          this.$noty.info(this.$t('general.copy'))
        }
      } catch (error) {
        console.log(error)
      }
      this.copyTextField = ''
      textToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    async confirmCreateAWS() {
      this.createAWS = false
      this.submitLoading = true
      const payload = {
        organization_id: this.orgId,
        account_type: this.accountType.type
      }
      const { ok, account } = await this.createAWSAccount(payload)

      if (ok) {
        this.$noty.success(
          this.$t(
            'organization.details.tabs.integrations.amazon_ses.messages.success.save'
          )
        )
        this.submitLoading = false
        this.close()
      } else {
        this.submitLoading = false
        this.$noty.error(
          this.$t(
            'organization.details.tabs.integrations.amazon_ses.messages.error.save'
          )
        )
      }
    }
  }
}
</script>
